<template>
  <div class="new-invoice pb-9">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card class="dialog-card pa-0">
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text class="pt-3">
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >n</v-btn
          >
          <b>افزودن مشتری جدید</b>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >q</v-btn
          >
          <b>بستن این راهنما</b>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-btn
      color="primary"
      style="float: right"
      @click="openAddCustomer()"
      v-shortkey.once="['n']"
      @shortkey="openAddCustomer()"
      hidden
    >
      ثبت مشتری جدید +
    </v-btn>
    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2 ps-2">فاکتور جدید</h4>
      </div>

      <hr class="mt-5" />
      <h4 class="primary--text mt-12">ثبت فاکتور جدید</h4>
      <div class="d-flex flex-row flex-wrap mt-5">
        <div class="custom-input d-flex flex-row flex-wrap">
          <v-text-field
            outlined
            dense
            hide-details
            type="number"
            dir="ltr"
            class="mb-2"
            label="شماره همراه مشتری"
            @keyup.enter="customerMobile ? searchCustomer() : ''"
            v-model="customerMobile"
          >
          </v-text-field>
          <v-btn
            @click="searchCustomer()"
            class="orange-mainBtn ms-2 mb-5"
            height="42"
            :disabled="!customerMobile"
          >
            جستجو
          </v-btn>
        </div>
        <div class="customSelect ms-0 mt-sm-3 ms-md-6 mt-sm-2 mt-md-0">
          <v-autocomplete
            @change="getBalance(newInvoice.shopCustomerId)"
            auto-select-first
            hide-details=""
            no-data-text="نتیجه‌ای یافت نشد!"
            v-model="newInvoice.shopCustomerId"
            :items="customers"
            item-text="name"
            item-value="id"
            class="pa-0 mb-3"
            label="* نام مشتری"
            :disabled="gettingCustomers"
            dense
            outlined
          >
            <template v-slot:append>
              <v-icon>$ArrowDown</v-icon>
            </template>
            <template slot="item" slot-scope="data">
              <!-- HTML that describe how select should render items when the select is open -->
              <img
                v-if="data.item.royaltyTier"
                :src="computedIcon(data.item)"
                style="height: 26px; width: 26px"
                class="me-1"
              />
              {{ data.item.name }}
            </template>
            <template slot="selection" slot-scope="data">
              <!-- HTML that describe how select should render items when the select is open -->
              <img
                v-if="data.item.royaltyTier"
                :src="computedIcon(data.item)"
                style="height: 26px; width: 26px"
                class="me-1"
              />
              {{ data.item.name }}
            </template>
          </v-autocomplete>
        </div>
      </div>
      <div v-if="gettingBalance">
        <looping-rhombuses-spinner
          :animation-duration="2500"
          :rhombus-size="15"
          color="#6200ea"
          class="mx-auto my-10"
        />
      </div>
      <div
        v-if="newInvoice.shopCustomerId && !gettingBalance"
        class="customer-info grey--text text--darken-2 mt-6 mb-3"
      >
        <v-row>
          <v-col sm="12" cols="12">
            <b class="me-1">مانده حساب:</b>
            <span v-if="newInvoice.customerBalance" class="ms-1">{{
              newInvoice.customerBalance
            }}</span>
          </v-col>
          <v-col sm="6" cols="12" class="pt-sm-0">
            <b class="me-1">مبلغ کل خریدهای پیشین:</b>
            {{ Number(allShopIncomeBalance).toLocaleString() }} تومان
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="6" cols="12" class="pt-sm-0">
            <b class="me-1">تاریخ اعتبار: </b>
            {{ royaltyCreditExpiryDate ? royaltyCreditExpiryDate : "-" }}
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="6" cols="12" class="pt-sm-0">
            <b class="me-1">میزان اعتبار باقی مانده:</b>
            {{ Number(royaltyCreditAmount).toLocaleString() }} تومان
          </v-col>
        </v-row>
      </div>

      <hr />
      <v-btn
        @click="
          titleFilter = '';
          barcodeFilter = '';
          productsDialog = true;
        "
        height="50"
        class="orange-borderedBtn w-100"
        :class="!newInvoice.shopCustomerId ? 'disabled' : ''"
        >* <v-icon class="me-2 ms-2">$Box</v-icon> افزودن کالا
      </v-btn>
      <span v-show="false">{{ reactivity }}</span>
      <div class="custom-table dashed mt-8 pb-2">
        <b-table
          responsive
          show-empty
          :items="selectedProducts"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="هنوز کالایی به فاکتور اضافه نشده است"
          striped
          thead-class="headClass"
          tbody-class="bodyClass"
        >
          <template v-slot:empty>
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              <v-icon class="red--text text--lightem-1 me-2"
                >mdi-alert-circle-outline</v-icon
              >
              <span class="red--text font-weight-bold text--lightem-1"
                >هنوز کالایی به فاکتور اضافه نشده است</span
              >
            </div>
          </template>
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:head(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(name)="data">
            <div
              style="
                text-align: center;
                vertical-align: middle;
                min-width: 300px;
              "
            >
              {{
                data.value +
                (data.item.color ? " / رنگ: " + data.item.color : "") +
                (data.item.size ? " / سایز: " + data.item.size : "") +
                (data.item.volume ? " / حجم :" + data.item.volume : "") +
                (data.item.dimension
                  ? " / ابعاد: " + data.item.dimension
                  : "") +
                (data.item.weight ? " / وزن: " + data.item.weight : "") +
                (data.item.producingCountry
                  ? " / محصول کشور: " + data.item.producingCountry
                  : "") +
                (data.item.productionYear
                  ? " / سال تولید: " + data.item.productionYear
                  : "") +
                (data.item.contents ? " / ترکیبات: " + data.item.contents : "")
              }}
            </div>
          </template>
          <template v-slot:cell(price)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ Number(data.value).toLocaleString() }}
            </div>
          </template>
          <template v-slot:cell(amount)="data">
            <div
              style="text-align: center; vertical-align: middle"
              class="d-flex flex-row justify-space-around"
            >
              <div
                class="add-btn"
                @click="addItem(data.item, 1, 'direct')"
                dir="ltr"
              >
                <span>+1</span>
              </div>
              <span style="padding: 2px 4px 0">{{ data.value }}</span>
              <div
                class="remove-btn"
                @click="reduceItem(data.item, data.index, 1)"
                dir="ltr"
              >
                <span>-1</span>
              </div>
              <div
                class="remove-btn"
                @click="reduceItem(data.item, data.index, 10)"
                dir="ltr"
                v-if="data.value > 9"
              >
                <span>-10</span>
              </div>
              <div
                class="remove-btn"
                @click="reduceItem(data.item, data.index, 100)"
                dir="ltr"
                v-if="data.value > 99"
              >
                <span>-100</span>
              </div>
            </div>
          </template>
          <template v-slot:cell(totalPrice)="data">
            <div style="text-align: center; vertical-align: middle">
              <span v-show="false">{{ reactivity }}</span>
              {{
                (Number(data.item.amount) * data.item.price).toLocaleString()
              }}
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              <span class="pointer" @click="removeItem(data.index, data.item)">
                <v-icon>$Delete</v-icon></span
              >
            </div>
          </template>
        </b-table>
        <div v-if="selectedProducts.length">
          <hr class="my-8" />
          <v-row>
            <v-col lg="6" md="12" cols="12" class="pb-1">
              <div class="mb-7" v-if="Number(royaltyCreditAmount) > 0">
                <span
                  @click="
                    newInvoice.useCredit = !newInvoice.useCredit;
                    newInvoice.discount = 0;
                    dissountModel = '';
                  "
                  class="pointer"
                >
                  <v-icon v-if="newInvoice.useCredit"> $PurpleChecked </v-icon>
                  <v-icon v-else> $PurpleUnchecked </v-icon>

                  <span
                    class="ms-3"
                    :class="
                      !newInvoice.useCredit
                        ? 'grey--text text--darken-2'
                        : 'primary--text font-weight-bold'
                    "
                    >استفاده از مبلغ اعتبار</span
                  >
                </span>
              </div>
              <div v-if="!newInvoice.useCredit">
                <p>
                  در صورت تمایل به ارائه محصول با تخفیف یکی از دو گزینه زیر را
                  انتخاب کنید:
                </p>
                <v-radio-group v-model="discountModel">
                  <v-radio label="تخفیف (درصدی)" value="discountByPercentage">
                  </v-radio>
                  <v-radio
                    label="تخفیف (تومانی)"
                    value="discountByAmount"
                  ></v-radio>
                </v-radio-group>
              </div>
              <div v-if="!newInvoice.useCredit" class="custom-input mb-7">
                <v-text-field
                  v-if="discountModel == 'discountByPercentage'"
                  label="تخفیف (درصد)"
                  v-model="newInvoice.discountPercentage"
                  @input="computedTotalDiscount"
                  hide-details
                  type="number"
                  outlined
                  dense
                  min="0"
                  max="100"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; this.value = Math.abs(this.value)"
                  class="w-100"
                ></v-text-field>
                <v-text-field
                  v-if="discountModel == 'discountByAmount'"
                  label="تخفیف (تومانی)"
                  v-model="newInvoice.discount"
                  hide-details
                  type="number"
                  outlined
                  dense
                  class="w-100"
                ></v-text-field>
              </div>
              <!-- <div class="custom-input mb-7">
                <v-text-field
                  v-if="discountModel == 'discountByPercentage'"
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  max="100"
                  oninput="if(Number(this.value) > Number(this.max))
                   this.value = this.max;
                  this.value = Math.abs(this.value)"
                  label="مالیات (درصد)"
                  class="w-100"
                  v-model="newInvoice.vat"
                  @input="computedTotalDiscount"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  max="100"
                  oninput="if(Number(this.value) > Number(this.max))
                   this.value = this.max;
                  this.value = Math.abs(this.value)"
                  label="مالیات (درصد)"
                  class="w-100"
                  v-model="newInvoice.vat"
                ></v-text-field>
              </div> -->
              <div class="customSelect mb-6">
                <v-select
                  dense
                  outlined
                  hide-details
                  label="* نوع پرداخت"
                  :items="paymentTypes"
                  v-model="newInvoice.paymentType"
                >
                  <template v-slot:append>
                    <v-icon>$ArrowDown</v-icon>
                  </template>
                </v-select>
              </div>
            </v-col>
            <v-col lg="12" md="12" cols="12" class="pt-0">
              <div class="custom-input">
                <v-textarea
                  rows="3"
                  no-resize
                  dense
                  outlined
                  hide-details
                  label="توضیحات"
                  v-model="newInvoice.descrition"
                >
                </v-textarea>
              </div>
            </v-col>
          </v-row>
          <div
            v-if="newInvoice.paymentType == 'cheque'"
            class="pa-5 pt-10 mb-2 mt-8"
            style="
              border: 1px solid #ccc;
              border-radius: 7px;
              position: relative;
            "
          >
            <p
              class="px-4 c-grey"
              style="position: absolute; top: -9px; background-color: #fff"
            >
              اطلاعات چک را وارد کنید:
            </p>
            <v-row class="custom-input">
              <v-col class="py-0" sm="6" cols="12">
                <v-text-field
                  label="شماره چک"
                  v-model="check.number"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col class="py-0" sm="6" cols="12">
                <v-text-field
                  label="نام بانک"
                  v-model="check.bankName"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="custom-input">
              <v-col class="py-0" sm="6" cols="12">
                <v-text-field
                  label="شماره صیاد"
                  v-model="check.chequeSayyad"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col class="pt-0" sm="6" cols="12">
                <span id="checkDate">
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    append-icon="mdi-calendar-edit"
                    v-model="check.date"
                    label="تاریخ چک"
                    :editable="true"
                    class="date-input"
                  >
                  </v-text-field>
                </span>

                <date-picker
                  v-model="check.date"
                  element="checkDate"
                  color="#6200ea"
                />
              </v-col>
              <v-col class="pt-0"> </v-col>
            </v-row>
            <div v-if="computedCheckInfo" class="d-flex flex-row">
              <v-icon class="red--text me-1">mdi-alert-circle-outline</v-icon>
              <span class="red--text"
                >وارد کردن شماره چک، نام بانک و تاریخ چک الزامی است.</span
              >
            </div>
          </div>
          <hr class="my-8" />
          <v-row class="c-grey" style="font-size: 17px">
            <v-col lg="6" md="12" cols="12">
              <v-row>
                <v-col>
                  <span> قیمت کل </span>
                </v-col>
                <v-col>
                  {{ Number(computedTotalPrice).toLocaleString() + " تومان " }}
                </v-col>
              </v-row>
              <v-row v-if="!newInvoice.useCredit">
                <v-col>
                  <span> تخفیف </span>
                </v-col>
                <v-col v-if="discountModel == ''"> 0 </v-col>
                <v-col v-if="discountModel == 'discountByPercentage'">
                  <span v-show="false">{{ reactivity }}</span>
                  {{ Number(newInvoice.discount).toLocaleString() + " تومان " }}
                </v-col>
                <v-col v-if="discountModel == 'discountByAmount'">
                  <span v-show="false">{{ reactivity }}</span>
                  {{
                    newInvoice.discount != ""
                      ? Number(newInvoice.discount).toLocaleString() + " تومان"
                      : "0"
                  }}
                </v-col>
              </v-row>
              <v-row v-if="newInvoice.useCredit">
                <v-col>
                  <span> مبلغ اعتبار </span>
                </v-col>
                <v-col>
                  {{ Number(royaltyCreditAmount).toLocaleString() }}
                  تومان
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col>
                  <span> مالیات </span>
                </v-col>
                <v-col>
                  {{
                    parseInt(
                      ((selectedProducts
                        .map((x) => Number(x.price) * Number(x.amount))
                        .reduce((a, b) => a + b, 0) -
                        (selectedProducts
                          .map((x) => Number(x.price) * Number(x.amount))
                          .reduce((a, b) => a + b, 0) *
                          newInvoice.discountPercentage) /
                          100) *
                        newInvoice.vat) /
                        100
                    ) > 0
                      ? parseInt(
                          (selectedProducts
                            .map((x) => Number(x.price) * Number(x.amount))
                            .reduce((a, b) => a + b, 0) /
                            100) *
                            newInvoice.vat
                        ).toLocaleString() + " تومان "
                      : 0
                  }}
                </v-col>
              </v-row> -->
            </v-col>
          </v-row>
          <hr class="mt-8 mb-4" />
          <v-row class="c-grey my-4" style="font-size: 19px">
            <v-col lg="6" md="12" cols="12" class="pb-0">
              <v-row>
                <v-col>
                  <span> مبلغ قابل پرداخت</span>
                </v-col>
                <v-col v-if="!newInvoice.useCredit && discountModel == ''">
                  <span v-show="false">{{ reactivity }}</span>
                  {{ !finalCost ? "مبلغ کل فاکتور منفی شده است." : finalCost }}
                </v-col>
                <v-col
                  v-if="
                    !newInvoice.useCredit &&
                    discountModel == 'discountByPercentage'
                  "
                >
                  <span v-show="false">{{ reactivity }}</span>
                  {{ !finalCost ? "مبلغ کل فاکتور منفی شده است." : finalCost }}
                </v-col>
                <v-col
                  v-if="
                    !newInvoice.useCredit && discountModel == 'discountByAmount'
                  "
                >
                  <span v-show="false">{{ reactivity }}</span>
                  {{
                    parseInt(
                      computedTotalPrice * (1 + Number(newInvoice.vat) / 100) -
                        newInvoice.discount
                    ).toLocaleString() + "  تومان "
                  }}
                </v-col>
                <v-col v-if="newInvoice.useCredit">
                  {{
                    royaltyCreditAmount >
                    (selectedProducts
                      .map((x) => Number(x.price) * Number(x.amount))
                      .reduce((a, b) => a + b, 0) *
                      (100 + Number(newInvoice.vat))) /
                      100
                      ? 0
                      : parseInt(
                          (selectedProducts
                            .map((x) => Number(x.price) * Number(x.amount))
                            .reduce((a, b) => a + b, 0) *
                            (100 + Number(newInvoice.vat))) /
                            100 -
                            Number(royaltyCreditAmount)
                        ).toLocaleString() + " تومان "
                  }}
                </v-col>
              </v-row>
            </v-col>
            <v-col class="text-left pb-0">
              <v-btn
                :disabled="computedBtn"
                @click="addInvoice()"
                elevation="0"
                color="green"
              >
                <span class="white--text">
                  <v-icon small class="white--text">mdi-check-outline</v-icon>
                  ثبت
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
    <v-snackbar v-model="snackbar" timeout="2000" color="green" top>
      <div class="w-100 text-center">
        <v-icon class="white--text me-1">mdi-check-decagram</v-icon>
        {{ text }}
      </div>
    </v-snackbar>
    <v-snackbar v-model="errorSnackbar" timeout="2000" color="red" top>
      <div class="w-100 text-center">
        <v-icon class="white--text me-1">mdi-alert-circle-outline</v-icon>
        موجودی انبار کافی نیست!
      </div>
    </v-snackbar>
    <v-dialog v-model="productsDialog" fullscreen persistent>
      <v-card class="dialog-card">
        <div class="d-sm-flex flex-row d-none justify-space-between py-3">
          <div class="d-flex flex-row">
            <h4 class="mb-0 pt-2">محصولات</h4>
            <v-divider class="me-10 ms-10" vertical></v-divider>
            <div class="custom-input2">
              <v-text-field
                hide-details
                outlined
                dense
                label="جستجو در عناوین محصولات..."
                prepend-inner-icon="$Search"
                @input="
                  currentPage = 1;
                  reactivity = !reactivity;
                "
                v-model="titleFilter"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="titleFilter.length"
                    class="red--text text--lighten-2"
                    @click="
                      titleFilter = '';
                      currentPage = 1;
                    "
                    >mdi-close-circle</v-icon
                  >
                </template>
              </v-text-field>
            </div>
            <v-divider class="me-10 ms-10" vertical></v-divider>
            <div class="custom-input2">
              <v-text-field
                hide-details
                outlined
                dense
                label="جستجو در شماره بارکد..."
                prepend-inner-icon="$Search"
                @input="
                  currentPage = 1;
                  reactivity = !reactivity;
                "
                v-model="barcodeFilter"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="barcodeFilter.length"
                    class="red--text text--lighten-2"
                    @click="
                      barcodeFilter = '';
                      currentPage = 1;
                    "
                    >mdi-close-circle</v-icon
                  >
                </template>
              </v-text-field>
            </div>
          </div>
          <span class="pointer" @click="productsDialog = false"
            ><v-icon>$Close</v-icon></span
          >
        </div>

        <div class="d-sm-none d-block flex-row justify-space-between py-3">
          <div>
            <div class="d-flex justify-space-between">
              <h4>محصولات</h4>
              <span class="pointer" @click="productsDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </div>
            <div class="custom-input mt-4">
              <v-text-field
                hide-details
                outlined
                dense
                label="جستجو در عناوین محصولات..."
                prepend-inner-icon="$Search"
                @input="
                  currentPage = 1;
                  reactivity = !reactivity;
                "
                v-model="titleFilter"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="titleFilter.length"
                    class="red--text text--lighten-2"
                    @click="
                      titleFilter = '';
                      currentPage = 1;
                    "
                    >mdi-close-circle</v-icon
                  >
                </template>
              </v-text-field>
            </div>
            <v-divider vertical> </v-divider>
            <div class="custom-input2">
              <v-text-field
                hide-details
                outlined
                dense
                label="جستجو در شماره بارکد..."
                prepend-inner-icon="$Search"
                @input="
                  currentPage = 1;
                  reactivity = !reactivity;
                "
                v-model="barcodeFilter"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="barcodeFilter.length"
                    class="red--text text--lighten-2"
                    @click="
                      barcodeFilter = '';
                      currentPage = 1;
                    "
                    >mdi-close-circle</v-icon
                  >
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <hr />
        <div
          v-if="productsLoading"
          class="d-flex flex-column align-items-center mt-8 py-6"
        >
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            :color="'#6200ea'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
        <div v-else class="custom-table mt-5">
          <b-table
            responsive
            show-empty
            :current-page="currentPage"
            :per-page="perPage"
            :items="computedProducts"
            :fields="productsFields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد."
            striped
            thead-class="headClass"
            tbody-class="bodyClass"
          >
            <template v-slot:empty>
              <div
                style="text-align: center; vertical-align: middle"
                class="pt-0"
              >
                رکوردی برای نمایش وجود ندارد.
              </div>
            </template>
            <template v-slot:cell(available)="data">
              <div style="text-align: center; vertical-align: middle">
                <div v-if="!data.value" class="red-badge mx-auto">
                  اتمام موجودی
                </div>
                <div v-else class="green-badge mx-auto">موجود</div>
              </div>
            </template>
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell(variants)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  min-width: 200px;
                  max-width: 300px;
                "
              >
                {{ data.value.length }}
              </div>
            </template>
            <template v-slot:head(name)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (currentPage - 1) }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(name)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  min-width: 200px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(price)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }}
              </div>
            </template>
            <template v-slot:cell(sum)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  margin-top: -4px;
                "
              >
                <div v-if="Number(data.value) == 0" class="red-badge mx-auto">
                  اتمام موجودی
                </div>
                <div v-else>{{ data.value }}</div>
              </div>
            </template>

            <template v-slot:cell(operation)="data">
              <div
                style="text-align: center; vertical-align: middle"
                class="pt-0"
              >
                <v-btn
                  @click="addItem(data.item, 1, 'indirect')"
                  class="orange-mainBtn"
                >
                  افزودن
                </v-btn>
              </div>
            </template>
            <template v-slot:cell(color)="data">
              <div>
                {{ data.value ? data.value : "-" }}
              </div>
            </template>
            <template v-slot:cell(size)="data">
              <div class="text-center">
                {{ data.value ? data.value : "-" }}
              </div>
            </template>
            <template v-slot:cell(dimension)="data">
              <div class="text-center">
                {{ data.value ? data.value : "-" }}
              </div>
            </template>
            <template v-slot:cell(weight)="data">
              <div class="text-center">
                {{ data.value ? data.value : "-" }}
              </div>
            </template>
            <template v-slot:cell(volume)="data">
              <div class="text-center">
                {{ data.value ? data.value : "-" }}
              </div>
            </template>
            <template v-slot:cell(producingCountry)="data">
              <div class="text-center">
                {{ data.value ? data.value : "-" }}
              </div>
            </template>
            <template v-slot:cell(productionYear)="data">
              <div class="text-center">
                {{ data.value ? data.value : "-" }}
              </div>
            </template>
            <template v-slot:cell(contents)="data">
              <div v-if="data.value.length > 10">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attr }">
                    <span v-on="on" v-bind="attr">
                      {{ data.value.slice(0, 10) }} </span
                    ><span>...</span>
                  </template>
                  <div>
                    <span>
                      {{ data.value }}
                    </span>
                  </div>
                </v-tooltip>
              </div>
              <div v-else>{{ data.value ? data.value : "-" }}</div>
            </template>
            <template v-slot:cell(expireDate)="data">
              <div class="text-center">
                {{ data.value ? data.value : "-" }}
              </div>
            </template>
          </b-table>
          <div class="blue-custom-pagination mt-6">
            <v-pagination
              v-model="currentPage"
              :length="Math.ceil(computedProducts.length / perPage)"
              :total-visible="5"
              prev-icon="$ArrowLeft"
              next-icon="$ArrowRight"
              class="float-end"
            ></v-pagination>
          </div>
        </div>
        <hr />
        <div class="py-1">
          <div v-if="!selectedProducts.length">
            <v-icon class="red--text text--lightem-1 me-2"
              >mdi-alert-circle-outline</v-icon
            >
            <span class="red--text font-weight-bold text--lightem-1"
              >هنوز کالایی به فاکتور اضافه نشده است.</span
            >
          </div>
          <div class="d-flex" v-else>
            <v-icon class="orange-icon primary--text me-3">$BoxChecked</v-icon>
            <span class="primary--text pt-2"
              >{{
                selectedProducts
                  .map((x) => Number(x.amount))
                  .reduce((a, b) => a + b, 0)
              }}
              کالا به فاکتور اضافه شد.</span
            >
            <v-btn
              @click="productsDialog = false"
              class="orange-borderedBtn ms-sm-10 ms-2"
              >دیدن فاکتور</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="openVariantsDialog" width="1200" persistent>
      <v-card class="dialog-card">
        <v-container>
          <div class="d-sm-flex flex-row d-none justify-space-between py-3">
            <div class="d-flex flex-row">
              <h4 class="mb-0 pt-2">تنوعات محصول</h4>
              <v-divider class="me-10 ms-10" vertical></v-divider>
              <div class="custom-input2">
                <v-text-field
                  hide-details
                  outlined
                  dense
                  label="جستجو در شماره بارکد..."
                  prepend-inner-icon="$Search"
                  @input="
                    currentPage = 1;
                    reactivity = !reactivity;
                  "
                  v-model="barcodeFilter"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="barcodeFilter.length"
                      class="red--text text--lighten-2"
                      @click="
                        barcodeFilter = '';
                        currentPage = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
              </div>
            </div>
            <span class="pointer" @click="openVariantsDialog = false"
              ><v-icon>$Close</v-icon></span
            >
          </div>

          <div class="d-sm-none d-block flex-row justify-space-between py-3">
            <div>
              <div class="d-flex justify-space-between">
                <h4>تنوعات محصول</h4>
                <span class="pointer" @click="openVariantsDialog = false"
                  ><v-icon>$Close</v-icon></span
                >
              </div>
              <div class="custom-input mt-4">
                <v-text-field
                  hide-details
                  outlined
                  dense
                  label="جستجو در شماره بارکد..."
                  prepend-inner-icon="$Search"
                  @input="
                    currentPage = 1;
                    reactivity = !reactivity;
                  "
                  v-model="barcodeFilter"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="barcodeFilter.length"
                      class="red--text text--lighten-2"
                      @click="
                        barcodeFilter = '';
                        currentPage = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
              </div>
            </div>
          </div>
          <hr />
          <div
            v-if="productsLoading"
            class="d-flex flex-column align-items-center mt-8 py-6"
          >
            <atom-spinner
              :animation-duration="1000"
              :size="80"
              :color="'#6200ea'"
            />
            <p class="primary--text font-weight-bold mt-4">
              در حال بارگذاری اطلاعات...
            </p>
          </div>
          <div v-else class="custom-table mt-5">
            <b-table
              responsive
              show-empty
              :current-page="variantCurrentPage"
              :per-page="variantPerPage"
              :items="productVariants"
              :fields="variantsFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(variants)="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    min-width: 200px;
                    max-width: 300px;
                  "
                >
                  {{ data.value.length }}
                </div>
              </template>
              <template v-slot:head(name)="data">
                <div style="text-align: right; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{
                    data.index + 1 + variantPerPage * (variantCurrentPage - 1)
                  }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(name)="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    min-width: 200px;
                  "
                >
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(price)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(sum)="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    margin-top: -4px;
                  "
                >
                  <div v-if="Number(data.value) == 0" class="red-badge mx-auto">
                    اتمام موجودی
                  </div>
                  <div v-else>{{ data.value }}</div>
                </div>
              </template>
              <template v-slot:cell(color)="data">
                <div>
                  {{ data.value ? data.value : "-" }}
                </div>
              </template>
              <template v-slot:cell(size)="data">
                <div class="text-center">
                  {{ data.value ? data.value : "-" }}
                </div>
              </template>
              <template v-slot:cell(demension)="data">
                <div class="text-center">
                  {{ data.value ? data.value : "-" }}
                </div>
              </template>
              <template v-slot:cell(weight)="data">
                <div class="text-center">
                  {{ data.value ? data.value : "-" }}
                </div>
              </template>
              <template v-slot:cell(volume)="data">
                <div class="text-center">
                  {{ data.value ? data.value : "-" }}
                </div>
              </template>
              <template v-slot:cell(producingCountry)="data">
                <div class="text-center">
                  {{ data.value ? data.value : "-" }}
                </div>
              </template>
              <template v-slot:cell(productionYear)="data">
                <div class="text-center">
                  {{ data.value ? data.value : "-" }}
                </div>
              </template>
              <template v-slot:cell(contents)="data">
                <div v-if="data.value.length > 10">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attr }">
                      <span v-on="on" v-bind="attr">
                        {{ data.value.slice(0, 10) }} </span
                      ><span>...</span>
                    </template>
                    <div>
                      <span>
                        {{ data.value }}
                      </span>
                    </div>
                  </v-tooltip>
                </div>
                <div v-else>{{ data.value ? data.value : "-" }}</div>
              </template>
              <template v-slot:cell(expireDate)="data">
                <div class="text-center">
                  {{ data.value ? data.value : "-" }}
                </div>
              </template>
              <template v-slot:cell(operation)="data">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    @click="addItem(data.item, 1, 'indirect')"
                    class="orange-mainBtn"
                    >افزودن به فاکتور</v-btn
                  >
                </div>
              </template>
            </b-table>
            <div class="blue-custom-pagination mt-6">
              <v-pagination
                v-model="variantCurrentPage"
                :length="Math.ceil(productVariants.length / variantPerPage)"
                :total-visible="5"
                prev-icon="$ArrowLeft"
                next-icon="$ArrowRight"
                class="float-end"
              ></v-pagination>
            </div>
          </div>
          <hr />
          <div class="py-1">
            <div v-if="!selectedProducts.length">
              <v-icon class="red--text text--lightem-1 me-2"
                >mdi-alert-circle-outline</v-icon
              >
              <span class="red--text font-weight-bold text--lightem-1"
                >هنوز کالایی به فاکتور اضافه نشده است.</span
              >
            </div>
            <div class="d-flex" v-else>
              <v-icon class="orange-icon primary--text me-3"
                >$BoxChecked</v-icon
              >
              <span class="primary--text pt-2"
                >{{
                  selectedProducts
                    .map((x) => Number(x.amount))
                    .reduce((a, b) => a + b, 0)
                }}
                کالا به فاکتور اضافه شد.</span
              >
              <v-btn
                @click="
                  productsDialog = false;
                  openVariantsDialog = false;
                "
                class="orange-borderedBtn ms-sm-10 ms-2"
                >دیدن فاکتور</v-btn
              >
            </div>
          </div>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="newCustomerDialog" width="700">
      <v-card class="dialog-card py-5 px-8">
        <h4>ثبت مشتری جدید</h4>
        <hr />
        <div>
          <div class="custom-input">
            <v-text-field
              outlined
              dense
              label="نام مشتری"
              v-model="newCustomer.name"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="شماره موبایل"
              :loading="busy"
              v-model="newCustomer.mobile"
            ></v-text-field>
          </div>
          <div class="customSelect">
            <v-select
              label="نوع مشتری"
              :items="customerTypes"
              v-model="newCustomer.type"
              :loading="busy"
              outlined
              dense
            />
          </div>
        </div>
        <v-row class="mt-2">
          <v-col class="text-left">
            <v-btn
              @click="addCustomer()"
              width="100"
              elevation="0"
              color="green"
              :disabled="
                !(newCustomer.name && newCustomer.mobile && newCustomer.type)
              "
            >
              <span class="white--text">
                <v-icon small class="white--text">mdi-check-outline</v-icon>
                ثبت
              </span>
            </v-btn>
            <v-btn
              @click="newCustomerDialog = false"
              width="100"
              elevation="0"
              color="red"
              class="ms-3"
            >
              <span class="white--text">
                <v-icon small class="white--text">mdi-close-outline</v-icon>
                لغو
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- receipt -->
    <v-card>
      <div id="Receipt" v-show="false">
        <div
          v-if="newInvoice.shopCustomerId"
          class="mainTable"
          style="width: 100%; height: 100%"
        >
          <div style="margin-bottom: 15px">
            <div style="text-align: center; width: 100%">
              <img src="/pen.png" height="100px" alt="" />
            </div>
          </div>
          <tbody>
            <tr>
              <td>
                <div
                  class="content"
                  style="padding: 5px 0px; margin-bottom: 15px"
                >
                  <div>
                    <div>
                      <div style="text-align: center">
                        <strong style="font-size: 17px"
                          >{{
                            customers.filter(
                              (x) => x.id == newInvoice.shopCustomerId
                            )[0].name
                          }}
                          عزیز، از دیدن دوباره شما خوش‌حالیم!</strong
                        >
                      </div>
                      <table
                        v-if="newInvoice.shopCustomerId"
                        style="
                          border: 0px solid black !important;
                          margin-top: 15px;
                        "
                      >
                        <tr>
                          <td style="border: 0px solid black !important">
                            تاریخ خرید:
                            {{ moment(new Date()).format("jYYYY/jMM/jDD") }}
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            <span style="font-size = 16px">{{
                              receiptNumber
                            }}</span>
                          </td>
                        </tr>
                      </table>

                      <br />
                    </div>
                  </div>
                  <b-table
                    v-if="purchaseDone"
                    bordered
                    :fields="receiptFields"
                    :items="selectedProducts"
                    small="small"
                    responsive
                  >
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell(name)="data">
                      <div
                        style="
                          text-align: center;
                          vertical-align: middle;
                          min-width: 300px;
                        "
                      >
                        {{
                          data.value +
                          (data.item.color
                            ? " / رنگ: " + data.item.color
                            : "") +
                          (data.item.size ? " / سایز: " + data.item.size : "") +
                          (data.item.volume
                            ? " / حجم :" + data.item.volume
                            : "") +
                          (data.item.dimension
                            ? " / ابعاد: " + data.item.dimension
                            : "") +
                          (data.item.weight
                            ? " / وزن: " + data.item.weight
                            : "") +
                          (data.item.producingCountry
                            ? " / محصول کشور: " + data.item.producingCountry
                            : "") +
                          (data.item.productionYear
                            ? "  / سال تولید: " + data.item.productionYear
                            : "") +
                          (data.item.contents
                            ? " / ترکیبات: " + data.item.contents
                            : "")
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(amount)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value.toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(price)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(totalPrice)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          (
                            Number(data.item.amount) * data.item.price
                          ).toLocaleString()
                        }}
                      </div>
                    </template>
                  </b-table>
                  <div
                    style="padding: 10px 0 0; text-align: center"
                    v-if="newInvoice.useCredit"
                  >
                    <span style="font-size: 13px; font-weight: bold"
                      >در این خرید از اعتبار استفاده نموده‌اید.</span
                    >
                  </div>
                  <br />
                  <table
                    v-if="newInvoice.shopCustomerId"
                    style="
                      border: 0px solid black !important;
                      margin-bottom: 10px;
                    "
                  >
                    <tr style="margin-bottom: 15px">
                      <td style="border: 0px solid black !important">
                        جمع اقلام:
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size = 16px"
                          >{{
                            selectedProducts
                              .map((x) => Number(x.amount))
                              .reduce((a, b) => a + b, 0)
                          }}
                        </span>
                      </td>
                    </tr>
                    <tr style="margin-bottom: 15px">
                      <td style="border: 0px solid black !important">
                        جمع کل (تومان):
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size = 16px"
                          >{{
                            selectedProducts
                              .map((x) => Number(x.price) * Number(x.amount))
                              .reduce((a, b) => a + b, 0)
                              .toLocaleString()
                          }}
                        </span>
                      </td>
                    </tr>
                    <!-- <tr style="margin-bottom: 15px">
                      <td style="border: 0px solid black !important">
                        مالیات (تومان):
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size = 16px"
                          >{{
                            parseInt(
                              ((selectedProducts
                                .map((x) => Number(x.price) * Number(x.amount))
                                .reduce((a, b) => a + b, 0) -
                                (selectedProducts
                                  .map(
                                    (x) => Number(x.price) * Number(x.amount)
                                  )
                                  .reduce((a, b) => a + b, 0) *
                                  newInvoice.discountPercentage) /
                                  100) *
                                newInvoice.vat) /
                                100
                            ) > 0
                              ? parseInt(
                                  (selectedProducts
                                    .map(
                                      (x) => Number(x.price) * Number(x.amount)
                                    )
                                    .reduce((a, b) => a + b, 0) /
                                    100) *
                                    newInvoice.vat
                                ).toLocaleString()
                              : 0
                          }}
                        </span>
                      </td>
                    </tr> -->
                    <tr
                      style="margin-bottom: 15px"
                      v-if="!newInvoice.useCredit"
                    >
                      <td style="border: 0px solid black !important">
                        تخفیف (تومان):
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size = 16px"
                          >{{ Number(newInvoice.discount).toLocaleString() }}
                        </span>
                      </td>
                    </tr>
                    <tr style="margin-bottom: 15px" v-else>
                      <td style="border: 0px solid black !important">
                        مبلغ اعتبار (تومان):
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size = 16px"
                          >{{ Number(royaltyCreditAmount).toLocaleString() }}
                        </span>
                      </td>
                    </tr>
                  </table>

                  <div class="totalCost" style="padding: 0 10px !important">
                    <table
                      v-if="newInvoice.shopCustomerId"
                      style="border: 0px solid black !important"
                    >
                      <tr>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: center;
                          "
                        >
                          مبلغ قابل پرداخت (تومان):
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: center;
                          "
                        >
                          <span
                            style="font-size = 16px"
                            v-if="!newInvoice.useCredit && discountModel == ''"
                          >
                            {{
                              !finalCost
                                ? "مبلغ کل فاکتور منفی شده است."
                                : finalCost
                            }}
                          </span>
                          <!-- discountByPercentage -->
                          <span
                            style="font-size = 16px"
                            v-if="
                              !newInvoice.useCredit &&
                              discountModel == 'discountByPercentage'
                            "
                          >
                            {{
                              !finalCost
                                ? "مبلغ کل فاکتور منفی شده است."
                                : finalCost
                            }}
                          </span>
                          <!-- discountByAmount -->
                          <span
                            style="font-size = 16px"
                            v-if="
                              !newInvoice.useCredit &&
                              discountModel == 'discountByAmount'
                            "
                          >
                            {{
                              parseInt(
                                computedTotalPrice *
                                  (1 + Number(newInvoice.vat) / 100) -
                                  newInvoice.discount
                              ).toLocaleString() + "  تومان "
                            }}
                          </span>

                          <span
                            style="font-size = 16px"
                            v-if="newInvoice.useCredit"
                            >{{
                              royaltyCreditAmount >
                              (selectedProducts
                                .map((x) => Number(x.price) * Number(x.amount))
                                .reduce((a, b) => a + b, 0) *
                                (100 + Number(newInvoice.vat))) /
                                100
                                ? 0
                                : parseInt(
                                    (selectedProducts
                                      .map(
                                        (x) =>
                                          Number(x.price) * Number(x.amount)
                                      )
                                      .reduce((a, b) => a + b, 0) *
                                      (100 + Number(newInvoice.vat))) /
                                      100 -
                                      Number(royaltyCreditAmount)
                                  ).toLocaleString()
                            }}
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <br />
                  <div class="barcode-box">
                    <barcode
                      :value="receiptNumber"
                      displayValue="false"
                      style="transform: translateX(50px)"
                    >
                    </barcode>
                  </div>
                  <div style="padding: 0 0 25px; text-align: center">
                    مرجوع کردن تا 72 ساعت پس از زمان خرید، با در دست داشتن این
                    فاکتور امکان پذیر است.
                  </div>
                  <div class="bot-box">
                    <div>از اینکه فروشگاه مارو انتخاب کردی خیلی ممنونیم (:</div>
                    <div>اینستاگرام: ace_pet_club</div>
                    <div>شماره تماس: 09124061268</div>
                    <div>
                      بلوار اندرزگو - بلوار صبا - کوچه کیارنک - نبش کوچه مقدم
                    </div>
                    <div class="border-top">
                      کتاب باز اس همه روزه از ساعت ۱۱ صبح الی ۸ شب منتظر شماست!
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </div>
      </div>
    </v-card>
    <!-- receipt -->
    <v-dialog width="500" persistent v-model="getReceiptDialog">
      <v-card class="pa-6">
        <div class="d-flex justify-content-center">
          <v-icon class="green--text me-2">mdi-check-decagram</v-icon>
          <h5 style="font-size: 17px" class="c-grey pt-2">
            فاکتور با موفقیت به ثبت رسید.
          </h5>
        </div>
        <div class="d-flex justify-space-around mt-10">
          <v-btn @click="printReceipt()" class="orange-mainBtn" width="160"
            ><v-icon class="me-1">mdi-printer</v-icon>چاپ مجدد رسید</v-btn
          >
          <v-btn @click="finish()" class="orange-borderedBtn" width="160"
            ><v-icon class="me-1">mdi-checkbox-marked-outline</v-icon
            >اتمام</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import VueBarcode from "vue-barcode";
import moment from "moment-jalaali";
import {
  AtomSpinner,
  HalfCircleSpinner,
  LoopingRhombusesSpinner,
} from "epic-spinners";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  components: {
    AtomSpinner,
    HalfCircleSpinner,
    LoopingRhombusesSpinner,
    barcode: VueBarcode,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      reactivity: false,
      openVariantsDialog: false,
      productVariants: [],
      selectedProduct: {},
      discountModel: "",
      discountByPercentage: false,
      discountByAmount: false,
      finalDiscount: "",
      royaltyCreditExpiryDate: null,
      moment: moment,
      getReceiptDialog: false,
      guide: false,
      reactivity: false,
      snackbar: false,
      errorSnackbar: false,
      busy: false,
      text: "",
      customers: [],
      products: [],
      selectedProducts: [],
      newCustomer: {},
      check: {},
      titleFilter: "",
      barcodeFilter: "",
      perPage: 5,
      variantPerPage: 5,
      variantCurrentPage: 1,
      currentPage: 1,
      productsDialog: false,
      productsLoading: false,
      gettingCustomers: false,
      newCustomerDialog: false,
      customerMobile: null,
      receiptNumber: "",
      royaltyCreditAmount: null,
      allShopIncomeBalance: null,
      royaltyCreditType: "none",

      newInvoice: {
        discountPercentage: 0,
        totalPrice: 0,
        customerBalance: "",
        shopCustomerId: null,
        paymentType: "",
        vat: 0,
        discount: 0,
        useCredit: false,
      },
      gettingBalance: false,
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
      ],
      paymentMethods: [
        { value: "use", text: "استفاده شود" },
        { value: "noUse", text: "استفاده نشود" },
      ],
      fields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "price", label: "قیمت واحد (تومان)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل (تومان)" },
        { key: "operation", label: "عملیات" },
      ],
      receiptFields: [
        // { key: "index", label: "ردیف" },
        { key: "name", label: "نام کالا" },
        { key: "price", label: "قیمت واحد (تومان)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "جمع کل (تومان)" },
      ],
      productsFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "price", label: "قیمت (تومان)" },
        { key: "sum", label: "موجودی انبار" },
        { key: "color", label: "رنگ", sortable: false },
        { key: "size", label: "سایز", sortable: false },
        { key: "volume", label: "حجم", sortable: false },
        { key: "dimension", label: "ابعاد", sortable: false },
        { key: "weight", label: "وزن", sortable: false },
        { key: "producingCountry", label: "کشور تولیدکننده", sortable: false },
        { key: "productionYear", label: "سال تولید", sortable: false },
        { key: "contents", label: "ترکیبات ", sortable: false },
        { key: "barcode", label: "بارکد" },
        { key: "expireDate", label: " تاریخ انقضا ", sortable: false },
        { key: "operation", label: "عملیات" },
      ],
      variantsFields: [
        { key: "color", label: "رنگ", sortable: false },
        { key: "size", label: "سایز", sortable: false },
        { key: "volume", label: "حجم", sortable: false },
        { key: "dimension", label: "ابعاد", sortable: false },
        { key: "weight", label: "وزن", sortable: false },
        { key: "producingCountry", label: "کشور تولیدکننده", sortable: false },
        { key: "productionYear", label: "سال تولید", sortable: false },
        { key: "contents", label: "ترکیبات ", sortable: false },
        { key: "sum", label: " موجودی ", sortable: false },
        { key: "barcode", label: " بارکد ", sortable: false },
        { key: "expireDate", label: " تاریخ انقضا ", sortable: false },
        { key: "price", label: " قیمت فروش (تومان)", sortable: false },
        { key: "operation", label: " عملیات ", sortable: false },
      ],
      customerTypes: [
        { value: "naturalPerson", text: "حقیقی" },
        { value: "legalPerson", text: "حقوقی" },
      ],
    };
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },

    variantsDialog(item) {
      this.openVariantsDialog = true;
      this.selectedProduct = item;
      this.productVariants = this.selectedProduct.variants;
    },
    disableDiscount() {
      if (this.useRoyaltyCredit) {
        this.newInvoice.discount = 0;
        return true;
      }
    },
    openAddCustomer() {
      this.newCustomer = {};
      this.guide = false;
      this.newCustomerDialog = true;
    },

    addItem(item, amount, type) {
      if (item.sum > 0) {
        let myIndex = this.selectedProducts.findIndex(
          (product) => product.id == item.id
        );
        if (myIndex == -1) {
          this.snackbar = false;
          this.errorSnackbar = false;
          let thisItem = item;
          thisItem.amount = Number(amount);
          this.selectedProducts.push(thisItem);
        } else {
          this.snackbar = false;
          this.errorSnackbar = false;
          this.selectedProducts[myIndex].amount =
            Number(this.selectedProducts[myIndex].amount) + Number(amount);
          this.reactivity = !this.reactivity;
        }
        item.sum--;
        if (type == "indirect") {
          this.text = amount + " عدد " + " به فاکتور افزوده شد";
          setTimeout(() => {
            this.snackbar = true;
          }, 100);
        }
      } else {
        this.snackbar = false;
        this.errorSnackbar = true;
      }

      this.computedTotalDiscount();
    },
    removeItem(index, item) {
      this.selectedProducts.splice(index, 1);
      this.products.forEach((x) => {
        if (x.id == item.id) {
          x.sum = x.sum + item.amount;
        }
      });
    },
    reduceItem(item, index, amount) {
      let myamount = item.amount;
      if (myamount <= amount) {
        this.selectedProducts.splice(index, 1);
      } else {
        this.selectedProducts[index].amount =
          Number(this.selectedProducts[index].amount) - Number(amount);
        this.reactivity = !this.reactivity;
      }
      item.sum = item.sum + amount;
      if (this.discountModel == "discountByPercentage") {
        this.computedTotalDiscount();
      }
    },
    getCustomers() {
      this.gettingCustomers = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingCustomers = false;
          if (res.status == 200) {
            this.customers = res.data;
            if (this.tempCustomer) {
              this.newInvoice.shopCustomerId = this.tempCustomer;
              this.getBalance(this.tempCustomer);
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.gettingCustomers = false;
          this.toast(err.response.data, "error");
        });
    },
    getBalance(customerId) {
      this.purchaseDone = false;
      this.gettingBalance = true;
      this.newInvoice.customerBalance = "";
      Axios.post(
        this.baseUrl + "/satrapp/shop/payments/customerBalance",
        {
          shopCustomerId: customerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.royaltyCreditAmount = res.data.royaltyCreditAmount;
            this.royaltyCreditExpiryDate = res.data.royaltyCreditExpiryDate;
            this.allShopIncomeBalance = res.data.allShopIncomeBalance;
            let royaltyCreditType = res.data.royaltyCreditType;
            this.royaltyCreditType =
              royaltyCreditType == "normal"
                ? "معمولی"
                : royaltyCreditType == "vip"
                ? "ویژه"
                : "فاقد اعتبار";
            this.newInvoice.customerBalance = Number(
              res.data.balanceData.balance.split(",").join("")
            );
            if (this.newInvoice.customerBalance > 0) {
              this.newInvoice.customerBalance =
                this.newInvoice.customerBalance.toLocaleString() +
                " تومان بدهکار";
            } else if (this.newInvoice.customerBalance < 0) {
              this.newInvoice.customerBalance =
                Math.abs(this.newInvoice.customerBalance).toLocaleString() +
                " تومان بستانکار";
            } else {
              this.newInvoice.customerBalance = "تسویه";
            }
            setTimeout(() => {
              this.gettingBalance = false;
            }, 500);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    searchCustomer() {
      this.busy = true;
      let myCustomer = {};
      myCustomer = this.customers.filter(
        (x) => x.mobile == this.customerMobile
      );
      if (myCustomer.length == 0) {
        this.newCustomer = {
          mobile: this.customerMobile,
          type: "naturalPerson",
        };
        this.newCustomerDialog = true;
      } else {
        this.newInvoice.shopCustomerId = myCustomer[0].id;
        this.getBalance(myCustomer[0].id);
      }
      this.busy = false;
    },
    addCustomer() {
      Axios.post(
        this.baseUrl + "/satrapp/shop/customer/new",
        {
          name: this.newCustomer.name,
          mobile: this.newCustomer.mobile,
          type: this.newCustomer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newCustomer = {};
            this.newCustomerDialog = false;
            this.getCustomers();
            this.tempCustomer = res.data.id;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    addInvoice() {
      this.purchaseDone = true;
      this.vLoading = true;
      let itemIds = [];
      this.selectedProducts.forEach((x) => {
        itemIds.push({
          amount: x.amount,
          variantId: x.id,
          parentId: x.parentItem,
        });
      });
      let sum =
        (this.selectedProducts
          .map((x) => Number(x.price) * Number(x.amount))
          .reduce((a, b) => a + b, 0) *
          (100 + Number(this.newInvoice.vat))) /
        100;
      Axios.post(
        this.baseUrl + "/satrapp/shop/sales/newWithVariant",
        {
          shopCustomerId: this.newInvoice.shopCustomerId,
          type: "definite",
          paymentType: this.newInvoice.paymentType,
          totalCost:
            this.discountModel == "discountByPercentage" &&
            !this.newInvoice.useCredit
              ? parseInt(
                  this.computedTotalPrice *
                    (1 + Number(this.newInvoice.vat) / 100) -
                    (this.computedTotalPrice *
                      (1 + Number(this.newInvoice.vat) / 100) *
                      Number(this.newInvoice.discountPercentage)) /
                      100
                )
              : this.discountModel == "discountByAmount" &&
                !this.newInvoice.useCredit
              ? parseInt(
                  this.computedTotalPrice *
                    (1 + Number(this.newInvoice.vat) / 100) -
                    this.newInvoice.discount
                )
              : this.royaltyCreditAmount <= sum &&
                this.discountModel == "" &&
                this.useRoyaltyCredit
              ? parseInt(
                  (this.selectedProducts
                    .map((x) => Number(x.price) * Number(x.amount))
                    .reduce((a, b) => a + b, 0) *
                    (100 + Number(this.newInvoice.vat))) /
                    100 -
                    Number(this.royaltyCreditAmount)
                )
              : this.royaltyCreditAmount > sum &&
                this.discountModel == "" &&
                this.newInvoice.useCredit
              ? 0
              : this.discountModel == "" && !this.newInvoice.useCredit
              ? parseInt(
                  this.computedTotalPrice *
                    (1 + Number(this.newInvoice.vat) / 100)
                )
              : 0,
          vat: Number(this.newInvoice.vat),
          discountType:
            this.discountModel == "discountByPercentage"
              ? "percentage"
              : this.discountModel == "discountByAmount"
              ? "number"
              : undefined,
          discount:
            this.discountModel == "discountByPercentage"
              ? this.finalDiscount
              : this.discountModel == "discountByAmount"
              ? Number(this.newInvoice.discount)
              : 0,
          itemIds: itemIds,
          details: this.selectedProducts,
          // expirationDate: this.expirationDate ? this.expirationDate : "",
          chequeNo: this.check.number ? this.check.number : "",
          chequeDate: this.check.date ? this.check.date : "",
          chequeSayyad: this.check.chequeSayyad ? this.check.chequeSayyad : "",
          chequeBank: this.check.bankName ? this.check.bankName : "",
          description: this.newInvoice.descrition
            ? this.newInvoice.descrition
            : "",
          useRoyaltyCredit: this.newInvoice.useCredit,
          royaltyDiscount: this.royaltyCreditAmount,
          totalBuyPrice: this.computedTotalBuyPrice,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.receiptNumber = res.data.invoiceCode;
            this.toast(res.data.message, "success");
            this.getReceiptDialog = true;
            this.vLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.vLoading = false;
          }
        })
        .then(() => {
          this.printReceipt();
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.vLoading = false;
        });
    },
    computedTotalDiscount() {
      let discount =
        parseInt(
          ((this.selectedProducts
            .map((x) => Number(x.price) * Number(x.amount))
            .reduce((a, b) => a + b, 0) +
            (this.selectedProducts
              .map((x) => Number(x.price) * Number(x.amount))
              .reduce((a, b) => a + b, 0) /
              100) *
              this.newInvoice.vat) *
            this.newInvoice.discountPercentage) /
            100
        ) > 0
          ? ((this.selectedProducts
              .map((x) => Number(x.price) * Number(x.amount))
              .reduce((a, b) => a + b, 0) +
              (this.selectedProducts
                .map((x) => Number(x.price) * Number(x.amount))
                .reduce((a, b) => a + b, 0) /
                100) *
                this.newInvoice.vat) *
              this.newInvoice.discountPercentage) /
            100
          : 0;
      this.finalDiscount =
        parseInt(
          ((this.selectedProducts
            .map((x) => Number(x.price) * Number(x.amount))
            .reduce((a, b) => a + b, 0) +
            (this.selectedProducts
              .map((x) => Number(x.price) * Number(x.amount))
              .reduce((a, b) => a + b, 0) /
              100) *
              this.newInvoice.vat) *
            this.newInvoice.discountPercentage) /
            100
        ) > 0
          ? ((this.selectedProducts
              .map((x) => Number(x.price) * Number(x.amount))
              .reduce((a, b) => a + b, 0) +
              (this.selectedProducts
                .map((x) => Number(x.price) * Number(x.amount))
                .reduce((a, b) => a + b, 0) /
                100) *
                this.newInvoice.vat) *
              this.newInvoice.discountPercentage) /
            100
          : 0;
      this.newInvoice.discount = discount;
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><link rel='stylesheet' href='/receipt.css'><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("Receipt").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    finish() {
      this.customerMobile = "";
      this.shopCustomerId = "";
      this.newInvoice = {
        discountPercentage: 0,
        totalPrice: 0,
        customerBalance: "",
        shopCustomerId: null,
        paymentType: "",
        vat: 0,
        discount: 0,
        useCredit: false,
      };
      this.selectedProducts = [];
      this.getCustomers();
      this.getProducts();
      this.getReceiptDialog = false;
    },
    getProducts() {
      this.productsLoading = true;
      Axios.get(
        this.baseUrl + "/satrapp/warehouse/warehouseItems/getAllWithVariants",
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.products = res.data;
            this.productsLoading = false;
          } else {
            this.toast(res.data, "error");
            this.productsLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.productsLoading = false;
        });
    },

    computedIcon(item) {
      if (item.royaltyTier == "coper") {
        return "/icons8-star-35(1).png";
      } else if (item.royaltyTier == "silver") {
        return "/icons8-star-35.png";
      } else if (item.royaltyTier == "gold") {
        return "/icons8-star-35(2).png";
      } else if (item.royaltyTier == "diamond") {
        return "/icons8-diamond-35.png";
      }
    },
  },
  computed: {
    computedProducts() {
      let filtered;
      filtered = this.products.filter(
        (x) =>
          x.name.toLowerCase().includes(this.titleFilter.toLowerCase()) &&
          String(x.barcode).includes(this.barcodeFilter)
      );
      return filtered;
    },
    computedTotalCost() {
      return (
        (this.selectedProducts
          .map((x) => Number(x.price) * Number(x.amount))
          .reduce((a, b) => a + b, 0) -
          this.computedTotalPrice *
            (this.newInvoice.discountPercentage / 100)) *
        (1 + Number(this.newInvoice.vat) / 100)
      );
    },
    computedTotalPrice() {
      let total = 0;
      this.selectedProducts.forEach((x) => {
        total = total + Number(x.amount) * Number(x.price);
      });
      this.reactivity = !this.reactivity;
      return total;
    },
    computedTotalBuyPrice() {
      let total = 0;
      this.selectedProducts.forEach((x) => {
        total = total + Number(x.amount) * Number(x.price);
      });
      this.reactivity = !this.reactivity;
      return total;
    },

    finalCost() {
      let result = 0;
      parseInt(
        this.computedTotalPrice * (1 + Number(this.newInvoice.vat) / 100) -
          (this.computedTotalPrice *
            (1 + Number(this.newInvoice.vat) / 100) *
            Number(this.newInvoice.discountPercentage)) /
            100
      ) > 0
        ? (result =
            parseInt(
              this.computedTotalPrice *
                (1 + Number(this.newInvoice.vat) / 100) -
                (this.computedTotalPrice *
                  (1 + Number(this.newInvoice.vat) / 100) *
                  Number(this.newInvoice.discountPercentage)) /
                  100
            ).toLocaleString() + " تومان ")
        : (result = 0);

      return result;
    },
    computedCheckInfo() {
      if (this.newInvoice.paymentType == "cheque") {
        if (!this.check.number || !this.check.bankName || !this.check.date) {
          return true;
        } else return false;
      } else return false;
    },
    computedBtn() {
      if (this.newInvoice.paymentType && this.newInvoice.shopCustomerId) {
        if (this.newInvoice.paymentType == "cheque") {
          if (!this.check.number || !this.check.bankName || !this.check.date) {
            return true;
          } else return false;
        } else return false;
      } else return true;
    },
  },
  mounted() {
    this.getProducts();
    this.getCustomers();
  },
};
</script>

<style lang="scss">
.new-invoice {
  .customSelect {
    width: 300px;
    @media only screen and (max-width: 768px) {
      width: 100%;
    }
    border-radius: 8px;
    .v-text-field .v-input__control,
    .v-text-field {
      fieldset {
        height: 48px !important;
        border-radius: 8px !important;
      }
    }
    .v-text-field > .v-input__control > .v-input__slot {
      &::before,
      &::after {
        display: none !important;
      }
    }
    .v-label {
      background-color: #fff;
      padding: 2px 6px 0;
    }
  }
  .dashed {
    min-height: 400px;
    .custom-input {
      .v-input__slot {
        width: 100% !important;
      }
      .v-text-field .v-input__control,
      .v-text-field fieldset {
        min-height: 50px !important;
      }
      .mdi:before {
        margin-top: 6px;
      }
    }
    .customSelect {
      width: 100% !important;
      .v-text-field .v-input__control,
      .v-text-field fieldset {
        min-height: 50px !important;
      }
    }
  }
  .add-btn {
    width: 24px;
    height: 24px;
    border: 1px solid #12b8a1;
    border-radius: 4px;
    background-color: #edfdf7;
    display: flex;
    justify-content: center;
    color: #12b8a1;
    cursor: pointer;
    user-select: none;
    span {
      transform: translateY(-3px);
    }
  }
  .remove-btn {
    min-width: 24px;
    height: 24px;
    border: 1px solid #f3536e;
    border-radius: 4px;
    background-color: FFE4E9;
    display: flex;
    justify-content: center;
    color: #f3536e;
    padding: 3px;
    cursor: pointer;
    user-select: none;
    span {
      transform: translateY(-3px);
    }
  }
  .customer-info {
    font-size: 15px;
    background-color: #f2f2f2;
    border-radius: 15px;
    padding: 20px 30px;
    @media only screen and (max-width: 768px) {
      padding: 20px 15px;
    }
  }
}
.dialog-card {
  border-radius: 15px !important;
  padding: 10px;

  .custom-table {
    max-height: 500px;
    overflow-y: auto;
    padding-left: -10px;

    &::-webkit-scrollbar {
      width: 8px !important;
      background-color: #ccc !important;
      border-radius: 4px !important;
    }
    &::-webkit-scrollbar {
      width: 8px !important;
      background-color: #ccc !important;
      border-radius: 4px !important;
    }
    &::-webkit-scrollbar-thumb {
      background: #979797c7 !important;
      border-radius: 4px !important;
    }
  }
  .custom-input {
    .v-input__slot {
      width: 100% !important;
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 50px !important;
    }
  }

  .customSelect {
    width: 100%;
    border-radius: 8px;
    .v-text-field .v-input__control,
    .v-text-field {
      fieldset {
        height: 48px !important;
        border-radius: 8px !important;
      }
    }
    .v-select__selection--comma {
      font-size: 14px !important;
    }
    .v-text-field > .v-input__control > .v-input__slot {
      &::before,
      &::after {
        display: none !important;
      }
    }
    .v-label {
      background-color: #fff;
      padding: 2px 6px 0;
    }
  }

  .orange-icon {
    path {
      stroke: #6200ea;
    }
  }
}
// .inputPrice >>> input[type="number"] {
//   -moz-appearance: textfield;
// }
.inputPrice >>> input::-webkit-outer-spin-button,
.inputPrice >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
